import * as ng from 'angular';
import { ContextMenu } from './context-menu.directive';

export const ContextMenuModule: string =
    ng.module('context-menu', [
    ])
        .directive('contextMenu', ContextMenu)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/context-menu/context-menu.module.ts